import React from 'react';
import { Radio } from 'antd';
import Text from 'components/Text/Text';
import style from './TypeOfChanges.module.scss';

interface IProps {
	setTypeOfChanges: (value: 'basedChanges' | 'independentChanges') => void;
	typeOfChanges: 'basedChanges' | 'independentChanges';
}

export const TypeOfChanges: React.FC<IProps> = React.memo(({ setTypeOfChanges, typeOfChanges }) => {
	return (
		<div className={style.container}>
			<div className={style.item}>
				<Radio checked={typeOfChanges === 'basedChanges'} onClick={() => setTypeOfChanges('basedChanges')}>
					<Text
						translationNameSpace="form"
						translationKey="restaurantBasedChangesLabel"
						size="s"
						weight="bold"
						theme="secondary"
					/>
				</Radio>
				<Text
					className={style.description}
					translationNameSpace="form"
					translationKey="restaurantBasedChangesDescription"
					size="s"
					theme="neutralLight"
				/>
			</div>
			<div className={style.item}>
				<Radio
					checked={typeOfChanges === 'independentChanges'}
					onClick={() => setTypeOfChanges('independentChanges')}>
					<Text
						translationNameSpace="form"
						translationKey="independentChangesLabel"
						size="s"
						weight="bold"
						theme="secondary"
					/>
				</Radio>
				<Text
					className={style.description}
					translationNameSpace="form"
					translationKey="independentChangesDescription"
					size="s"
					theme="neutralLight"
				/>
			</div>
		</div>
	);
});
